import { z } from 'zod'

import { isCalendarDate } from '../utils/calendar-date'

const identifier = z.string().trim().min(1).max(255)
const quantity = z.number().int().positive().max(2147483647)
export const inventoryAllocationFields = {
  serialIds: z
    .array(z.string().uuid())
    .max(10000)
    .refine(ids => new Set(ids).size === ids.length, 'Select each serial once')
    .optional(),
  batchAllocations: z
    .array(z.object({ batchId: z.string().uuid(), quantity }).strict())
    .max(10000)
    .refine(
      rows => new Set(rows.map(row => row.batchId)).size === rows.length,
      'Allocate each batch once',
    )
    .optional(),
  newSerialNumbers: z
    .array(identifier)
    .max(10000)
    .refine(
      values => new Set(values).size === values.length,
      'Enter each new serial once',
    )
    .optional(),
  newBatches: z
    .array(
      z
        .object({
          batchNumber: identifier,
          quantity,
          expirationDate: z
            .string()
            .refine(isCalendarDate, 'Choose a valid expiration date')
            .optional(),
        })
        .strict(),
    )
    .max(10000)
    .refine(
      rows => new Set(rows.map(row => row.batchNumber)).size === rows.length,
      'Enter each new batch once',
    )
    .optional(),
}
export interface InventoryAllocationQuery {
  receiving: boolean
  locationId?: string
  search?: string
  page?: number
}
export interface InventoryAllocationOptions {
  isSerialized: boolean
  hasBatches: boolean
  serials: { id: string; serialNumber: string }[]
  batches: {
    id: string
    batchNumber: string
    availableQuantity: number
    expirationDate: string | null
  }[]
  page: number
  hasMoreSerials: boolean
  hasMoreBatches: boolean
}
